import { render, staticRenderFns } from "./df.vue?vue&type=template&id=04e23bb6&scoped=true&"
import script from "./df.vue?vue&type=script&lang=js&"
export * from "./df.vue?vue&type=script&lang=js&"
import style0 from "./df.vue?vue&type=style&index=0&id=04e23bb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e23bb6",
  null
  
)

export default component.exports